'use strict';

import angular from 'angular';

/**
 * ContratsProliersController - contrôleur de la page des contrats pétroliers
 */
export default angular.module('observatoireApp')
  .controller('ContratsPetroliersController', ['$scope', '$http', '$filter', '$timeout', 'ContratsService',
    function($scope, $http, $filter, $timeout, ContratsService) {
      // État de chargement
      $scope.loading = {
        contrats: true,
        details: false
      };
      
      // Initialisation des filtres
      $scope.filtres = {
        texte: '',
        denomination: '',
        matiereContractee: '',
        typeContrat: '',
        status: ''
      };
      
      // Options de filtres (seront remplies avec les données)
      $scope.options = {
        denominations: [],
        matieres: [],
        typesContrat: [],
        statuts: []
      };
      
      // Initialisation du tableau de contrats
      $scope.contrats = [];
      $scope.contratsFiltres = [];
      
      // Contrat sélectionné pour affichage détaillé
      $scope.contratSelectionne = null;
      
      // Pagination
      $scope.pagination = {
        pageCourante: 1,
        elementsParPage: 10,
        nombrePages: 1
      };
      
      // Tri
      $scope.tri = {
        colonne: 'date',
        ordre: 'desc'
      };
      
      /**
       * Formater une date
       * @param {Array} dateArray Date au format [année, mois, jour, heure, minute]
       * @return {String} Date formatée
       */
      $scope.formatDate = function(dateArray) {
        console.log('Formatage de date:', dateArray);
        // Vérifier si la date est au format array [année, mois, jour, heure, minute]
        if (Array.isArray(dateArray) && dateArray.length >= 3) {
          const year = dateArray[0];
          // IMPORTANT: Le mois dans les tableaux Java commence à 0, donc on ajoute 1
          const month = (dateArray[1] + 1).toString().padStart(2, '0');
          const day = dateArray[2].toString().padStart(2, '0');
          const formatted = `${year}-${month}-${day}`;
          console.log('Date formatée:', formatted);
          return formatted;
        }
        // Si la date est déjà formatée ou n'est pas valide, la retourner telle quelle
        console.log('Date non formatée (déjà string ou invalide):', dateArray);
        return dateArray || '';
      };
      
      /**
       * Formater toutes les dates d'un contrat
       * @param {Object} contrat Contrat à formater
       * @return {Object} Contrat avec dates formatées
       */
      $scope.formatDatesContrat = function(contrat) {
        console.log('Formatage du contrat:', contrat);
        const contratFormate = angular.copy(contrat);
        
        // Formater les dates principales
        if (contratFormate.dateSignature) contratFormate.dateSignature = $scope.formatDate(contratFormate.dateSignature);
        if (contratFormate.dateFinPrevue) contratFormate.dateFinPrevue = $scope.formatDate(contratFormate.dateFinPrevue);
        if (contratFormate.dateFinProrogee) contratFormate.dateFinProrogee = $scope.formatDate(contratFormate.dateFinProrogee);
        if (contratFormate.dateResiliation) contratFormate.dateResiliation = $scope.formatDate(contratFormate.dateResiliation);
        if (contratFormate.dateDerniereModification) contratFormate.dateDerniereModification = $scope.formatDate(contratFormate.dateDerniereModification);
        if (contratFormate.dateEntreeVigueur) contratFormate.dateEntreeVigueur = $scope.formatDate(contratFormate.dateEntreeVigueur);
        
        // Pour la compatibilité avec les anciens champs
        if (contratFormate.date) contratFormate.date = $scope.formatDate(contratFormate.date);
        if (contratFormate.dateDebut) contratFormate.dateDebut = $scope.formatDate(contratFormate.dateDebut);
        if (contratFormate.dateFin) contratFormate.dateFin = $scope.formatDate(contratFormate.dateFin);
        
        console.log('Contrat après formatage des dates:', contratFormate);
        return contratFormate;
      };

      // Initialisation
      loadContrats();
      
      /**
       * Charge les contrats pétroliers
       */
      function loadContrats() {
        $scope.loading.contrats = true;
        
        ContratsService.getContrats()
          .then(function(data) {
            // Formater les dates qui viennent du backend au format [année, mois, jour, heure, minute]
            $scope.contrats = data.map(function(contrat) {
              return $scope.formatDatesContrat(contrat);
            });
            console.log($scope.contrats);
            // Appliquer le filtrage pour éliminer les lignes vides dès le départ
            $scope.filtrerContrats();
            
            // Extraire les options pour les filtres (après filtrage des lignes vides)
            extractFilterOptions();
            
            // Trier les résultats initiaux
            trierContrats();
            
            $scope.loading.contrats = false;
          })
          .catch(function(error) {
            console.error('Erreur lors du chargement des contrats pétroliers:', error);
            $scope.loading.contrats = false;
          });
      }
      
      /**
       * Extrait les options pour les filtres à partir des données de contrats
       */
      function extractFilterOptions() {
        // Extraire les dénominations uniques
        $scope.options.denominations = [...new Set($scope.contrats.map(c => c.denomination))].sort();
        
        // Extraire les matières contractées uniques
        $scope.options.matieres = [...new Set($scope.contrats.map(c => c.matiereContractee))].sort();
        
        // Extraire les types de contrat uniques
        $scope.options.typesContrat = [...new Set($scope.contrats.map(c => c.typeContrat))].sort();
        
        // Extraire les statuts uniques
        $scope.options.statuts = [...new Set($scope.contrats.map(c => c.status))].sort();
      }
      
      /**
       * Met à jour la pagination en fonction des données filtrées
       */
      function updatePagination() {
        $scope.pagination.nombrePages = Math.ceil($scope.contratsFiltres.length / $scope.pagination.elementsParPage);
        if ($scope.pagination.pageCourante > $scope.pagination.nombrePages) {
          $scope.pagination.pageCourante = 1;
        }
      }
      
      /**
       * Vérifie si un contrat contient des données significatives ou est vide
       * @param {Object} contrat - Le contrat à vérifier
       * @returns {boolean} - true si le contrat contient des données significatives, false sinon
       */
      function isContratValid(contrat) {
        // Vérifier que les champs essentiels ne sont pas vides ou null
        if (!contrat.denomination || contrat.denomination.trim() === '') return false;
        if (!contrat.reference || contrat.reference.trim() === '') return false;
        
        // Vérifier que les autres champs importants existent
        // On peut considérer un contrat valide même si certains champs secondaires sont vides
        let fieldsCount = 0;
        if (contrat.nif && contrat.nif.trim() !== '') fieldsCount++;
        if (contrat.matiereContractee && contrat.matiereContractee.trim() !== '') fieldsCount++;
        if (contrat.typeContrat && contrat.typeContrat.trim() !== '') fieldsCount++;
        if (contrat.status && contrat.status.trim() !== '') fieldsCount++;
        if (contrat.dateSignature) fieldsCount++;
        
        // Considérer le contrat comme valide s'il a au moins 3 champs significatifs en plus des champs essentiels
        return fieldsCount >= 3;
      }
      
      /**
       * Filtre les contrats selon les critères de recherche
       */
      $scope.filtrerContrats = function() {
        $scope.contratsFiltres = $scope.contrats.filter(function(contrat) {
          // D'abord vérifier si le contrat est valide (pas une ligne vide)
          if (!isContratValid(contrat)) return false;
          
          let matchTexte = true;
          let matchDenomination = true;
          let matchMatiere = true;
          let matchTypeContrat = true;
          let matchStatus = true;
          
          // Filtre par texte (recherche sur plusieurs champs)
          if ($scope.filtres.texte) {
            const searchText = $scope.filtres.texte.toLowerCase();
            matchTexte = 
              (contrat.denomination && contrat.denomination.toLowerCase().includes(searchText)) ||
              (contrat.nif && contrat.nif.toLowerCase().includes(searchText)) ||
              (contrat.reference && contrat.reference.toLowerCase().includes(searchText)) ||
              (contrat.matiereContractee && contrat.matiereContractee.toLowerCase().includes(searchText)) ||
              (contrat.typeContrat && contrat.typeContrat.toLowerCase().includes(searchText)) ||
              (contrat.status && contrat.status.toLowerCase().includes(searchText));
          }
          
          // Filtre par dénomination
          if ($scope.filtres.denomination) {
            matchDenomination = contrat.denomination === $scope.filtres.denomination;
          }
          
          // Filtre par matière contractée
          if ($scope.filtres.matiereContractee) {
            matchMatiere = contrat.matiereContractee === $scope.filtres.matiereContractee;
          }
          
          // Filtre par type de contrat
          if ($scope.filtres.typeContrat) {
            matchTypeContrat = contrat.typeContrat === $scope.filtres.typeContrat;
          }
          
          // Filtre par statut
          if ($scope.filtres.status) {
            matchStatus = contrat.status === $scope.filtres.status;
          }
          
          return matchTexte && matchDenomination && matchMatiere && matchTypeContrat && matchStatus;
        });
        
        // Mettre à jour la pagination après le filtrage
        updatePagination();
        
        // Réinitialiser la page courante
        $scope.pagination.pageCourante = 1;
      };
      
      /**
       * Trie les contrats selon la colonne et l'ordre spécifiés
       */
      $scope.trierContrats = function(colonne) {
        // Si on clique sur la même colonne, inverser l'ordre
        if (colonne === $scope.tri.colonne) {
          $scope.tri.ordre = $scope.tri.ordre === 'asc' ? 'desc' : 'asc';
        } else {
          $scope.tri.colonne = colonne;
          $scope.tri.ordre = 'asc';
        }
        
        trierContrats();
      };
      
      function trierContrats() {
        $scope.contratsFiltres.sort(function(a, b) {
          let valA = a[$scope.tri.colonne];
          let valB = b[$scope.tri.colonne];
          
          // Gestion des chaînes de caractères vs nombres
          if (typeof valA === 'string') {
            valA = valA.toLowerCase();
            valB = valB.toLowerCase();
          }
          
          if (valA < valB) {
            return $scope.tri.ordre === 'asc' ? -1 : 1;
          }
          if (valA > valB) {
            return $scope.tri.ordre === 'asc' ? 1 : -1;
          }
          return 0;
        });
      }
      
      /**
       * Change de page dans la pagination
       */
      $scope.changerPage = function(page) {
        if (page < 1 || page > $scope.pagination.nombrePages) {
          return;
        }
        $scope.pagination.pageCourante = page;
      };
      
      /**
       * Génère la liste des pages à afficher dans la pagination
       */
      $scope.getPages = function() {
        const pages = [];
        const totalPages = $scope.pagination.nombrePages;
        const currentPage = $scope.pagination.pageCourante;
        
        // Limiter le nombre de pages affichées
        const maxPagesToShow = 5;
        
        if (totalPages <= maxPagesToShow) {
          // Si le nombre total de pages est petit, afficher toutes les pages
          for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
          }
        } else {
          // Sinon, afficher les pages autour de la page courante
          let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
          let endPage = startPage + maxPagesToShow - 1;
          
          // Ajuster si on dépasse le nombre total de pages
          if (endPage > totalPages) {
            endPage = totalPages;
            startPage = Math.max(1, endPage - maxPagesToShow + 1);
          }
          
          for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
          }
        }
        
        return pages;
      };
      
      /**
       * Affiche les détails d'un contrat
       */
      $scope.afficherDetails = function(contrat) {
        // Réinitialiser les erreurs et l'état de chargement
        $scope.erreurDetails = null;
        $scope.loading.details = true;
        
        // Faire une copie propre du contrat pour éviter les modifications non désirées
        $scope.contratSelectionne = angular.copy(contrat);
        
        // Pré-initialiser les structures de données pour éviter les erreurs
        if (!$scope.contratSelectionne.participants) {
          $scope.contratSelectionne.participants = [];
        }
        
        if (!$scope.contratSelectionne.documents) {
          $scope.contratSelectionne.documents = [];
        }
        
        if (!$scope.contratSelectionne.avenants) {
          $scope.contratSelectionne.avenants = [];
        }
        
        // Afficher le titre du contrat dans le header du modal
        $('.modal-title').text('Détails du contrat: ' + $scope.contratSelectionne.reference);
        
        // Afficher le modal Bootstrap
        $('#modalDetailsContrat').modal('show');
        
        // En parallèle, charger les détails additionnels
        $timeout(function() {
          ContratsService.getContratDetails(contrat.id)
            .then(function(details) {
              if (details) {
                $scope.contratSelectionne.details = details;
              }
              $scope.loading.details = false;
            })
            .catch(function(error) {
              console.error('Erreur lors du chargement des détails du contrat:', error);
              $scope.loading.details = false;
              $scope.erreurDetails = 'Impossible de charger tous les détails du contrat.';
            });
        }, 200);
      };
      
      /**
       * Ferme le modal de détails
       */
      $scope.fermerDetails = function() {
        // Fermer le modal avec l'API Bootstrap
        $('#modalDetailsContrat').modal('hide');
        
        // Réinitialiser les états après la fermeture du modal
        $timeout(function() {
          $scope.contratSelectionne = null;
          $scope.erreurDetails = null;
        }, 300); // Laisser le temps à l'animation de fermeture de se terminer
      };
      
      /**
       * Télécharge un contrat
       */
      $scope.telechargerContrat = function(contrat, format) {
        ContratsService.telechargerContrat(contrat.id, format)
          .then(function(response) {
            // Simuler un téléchargement
            const element = document.createElement('a');
            const file = new Blob([response.data], {type: response.headers('Content-Type')});
            element.href = URL.createObjectURL(file);
            element.download = `Contrat_${contrat.numero}_${format}.${format}`;
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
          })
          .catch(function(error) {
            console.error('Erreur lors du téléchargement du contrat:', error);
            alert('Erreur lors du téléchargement du document. Veuillez réessayer.');
          });
      };
      
      /**
       * Réinitialise les filtres
       */
      $scope.reinitialiserFiltres = function() {
        $scope.filtres = {
          texte: '',
          annee: '',
          entreprise: '',
          bloc: ''
        };
        $scope.filtrerContrats();
      };
      
      /**
       * Exporte les contrats au format Excel (XLSX)
       */
      $scope.exportExcel = function() {
        const contratsAExporter = $scope.filteredContrats || $scope.contrats;
        
        // Vérifier et afficher le contenu des dates dans un contrat exemple
        if (contratsAExporter && contratsAExporter.length > 0) {
          console.log('Exemple de contrat avant formatage:', contratsAExporter[0]);
        }
        
        // Formater les dates pour l'export
        const contratsFormated = contratsAExporter.map(function(contrat) {
          // Créer une copie profonde pour éviter les références partagées
          const contratCopy = angular.copy(contrat);
          return $scope.formatDatesContrat(contratCopy);
        });
        
        // Vérifier et afficher le contrat formaté
        if (contratsFormated && contratsFormated.length > 0) {
          console.log('Exemple de contrat après formatage:', contratsFormated[0]);
        }
        
        ContratsService.exporterContrats(contratsFormated)
          .then(function(response) {
            // Afficher une notification de succès
            $scope.notifications.push({
              type: 'success',
              message: 'Export Excel réalisé avec succès'
            });
            
            // Le téléchargement est géré par l'utilitaire d'export
          })
          .catch(function(error) {
            console.error('Erreur lors de l\'exportation Excel:', error);
            // Afficher une notification d'erreur
            $scope.notifications.push({
              type: 'error',
              message: 'Erreur lors de l\'export Excel. Veuillez réessayer.'
            });
          });
      };  
      
      // S'assurer que l'objet notifications existe
      if (!$scope.notifications) {
        $scope.notifications = [];
      }

      /**
       * Génère un PDF des contrats et le télécharge
       */
      $scope.imprimer = function() {
        // Créer une notification pour indiquer que le PDF est en cours de génération
        $scope.notifications.push({
          type: 'info',
          message: 'Génération du PDF en cours...'
        });

        // Utiliser window.print() avec une mise en forme CSS spéciale pour l'impression
        // On va créer une feuille de style temporaire pour l'impression
        const style = document.createElement('style');
        style.id = 'print-style';
        style.innerHTML = `
          @media print {
            body * {
              visibility: hidden;
            }
            #print-section, #print-section * {
              visibility: visible;
            }
            #print-section {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
            }
            .no-print {
              display: none;
            }
            table {
              width: 100%;
              border-collapse: collapse;
            }
            th {
              background-color: #4472c4 !important;
              color: white !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            th, td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: left;
            }
            tr:nth-child(even) {
              background-color: #f2f2f2;
            }
            h2 {
              color: #333;
            }
          }
        `;
        document.head.appendChild(style);

        // Créer une section d'impression temporaire
        let printSection = document.getElementById('print-section');
        if (!printSection) {
          printSection = document.createElement('div');
          printSection.id = 'print-section';
          document.body.appendChild(printSection);
        }

        // Récupérer les contrats filtrés
        const contratsAExporter = $scope.contratsFiltres || $scope.contrats;

        // Formater les dates pour l'export
        const contratsFormated = contratsAExporter.map(function(contrat) {
          const contratCopy = angular.copy(contrat);
          return $scope.formatDatesContrat(contratCopy);
        });

        // Générer le HTML pour l'impression
        let htmlContent = `
          <div style="padding: 20px;">
            <h2>Liste des contrats pétroliers</h2>
            <p>Date d'export: ${new Date().toLocaleDateString('fr-FR')}</p>
            <p>Nombre de contrats: ${contratsFormated.length}</p>
            <table>
              <thead>
                <tr>
                  <th>Référence</th>
                  <th>Dénomination</th>
                  <th>NIF</th>
                  <th>Type de contrat</th>
                  <th>Statut</th>
                  <th>Date de signature</th>
                  <th>Date d'entrée en vigueur</th>
                  <th>Date de fin prévue</th>
                </tr>
              </thead>
              <tbody>
        `;

        // Ajouter les données des contrats
        contratsFormated.forEach(contrat => {
          htmlContent += `
            <tr>
              <td>${contrat.reference || ''}</td>
              <td>${contrat.denomination || ''}</td>
              <td>${contrat.nif || ''}</td>
              <td>${contrat.typeContrat || ''}</td>
              <td>${contrat.status || ''}</td>
              <td>${contrat.dateSignature || contrat.date || ''}</td>
              <td>${contrat.dateEntreeVigueur || contrat.dateDebut || ''}</td>
              <td>${contrat.dateFinPrevue || contrat.dateFin || ''}</td>
            </tr>
          `;
        });

        htmlContent += `
              </tbody>
            </table>
          </div>
        `;

        // Insérer le HTML dans la section d'impression
        printSection.innerHTML = htmlContent;

        // Déclencher l'impression
        $timeout(function() {
          window.print();
          
          // Nettoyage après impression
          $timeout(function() {
            // Supprimer la feuille de style temporaire
            const styleElement = document.getElementById('print-style');
            if (styleElement) {
              styleElement.parentNode.removeChild(styleElement);
            }
            
            // Notifier l'utilisateur que l'impression est terminée
            $scope.notifications = $scope.notifications.filter(n => n.message !== 'Génération du PDF en cours...');
            $scope.notifications.push({
              type: 'success',
              message: 'Document prêt à être imprimé ou enregistré en PDF'
            });
          }, 1000);
        }, 500);
      };
    }
  ]);
